import type { WireSpec } from "../wire-tables";
import { formatNumber } from "../utils";
import { metresToFeet, type UnitSystem } from "./units";

export function formatWire(spec: WireSpec, units: UnitSystem): string {
  return units === "imperial" ? `AWG ${spec.awg}` : `${Number(spec.mm2.toFixed(2))} mm²`;
}

/** The *other* unit, so the inspector can show both ("AWG 10 · 6 mm²"). */
export function formatWireSecondary(spec: WireSpec, units: UnitSystem): string {
  return units === "imperial" ? `${Number(spec.mm2.toFixed(2))} mm²` : `AWG ${spec.awg}`;
}

export function formatLength(meters: number, units: UnitSystem): string {
  if (units === "imperial") {
    const ft = metresToFeet(meters);
    return `${formatNumber(ft, 1)} ft`;
  }
  if (meters < 1) return `${Math.round(meters * 100)} cm`;
  return `${formatNumber(meters, 1)} m`;
}

export function lengthUnitLabel(units: UnitSystem): string {
  return units === "imperial" ? "ft" : "m";
}

export function wireUnitLabel(units: UnitSystem): string {
  return units === "imperial" ? "AWG" : "mm²";
}
